import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const RushContent = styled(Box)(({ theme }) => ({
  maxWidth: '760px',
  fontFamily: 'Work Sans',
  display: 'flex',
  paddingTop: '10px',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
}));

export const RushImageWrapper = styled(Box)(({ theme }) => ({
  borderRadius: theme.spacing(1),
  overflow: 'hidden',
  position: 'relative',
}));
